export const environment = {
  production: false,
  version: '6.2.4',
  mockData: false,
  apiUrl: 'https://amlapi-stage.starexchangealliance.com',
  crmApiUrl: 'https://crm-dev.starcompliance.io',
  crmApiKey: 'bjWtIWZXl1kxG_X6QrWK1x5rW1bmiTQQZaZ6bZrTq7es',
  backOfficeUrl: 'https://amladmin-stage.starexchangealliance.com',
  hasDarkTheme: false,
  devMode: true,
  linkWebVersion: 'https://aml-stage.starexchangealliance.com'
};
